<template>
  <div :class="getClassDiv">
    <label>{{ label }}</label>
    <DropDown
      :id="id"
      v-model="value"
      :options="options"
      :class="setClass"
      optionLabel="descricao"
      :optionValue="optionValue"
      :placeholder="placeholder"
      :editable="editavel"
    />
    <small v-if="temErro" class="p-error"
      >{{ obterMensagemCampoObrigatorio }}
    </small>
  </div>
</template>

<script>
import DropDown from "primevue/dropdown";
import ValidacaoMixin from "@/mixins/validacao";

export default {
  name: "DropDownLabel",

  mixins: [ValidacaoMixin],
  
  props: {
    optionValue: null,
    id: String,
    label: String,
    options: Array,
    class: String,
    temErro: {
      type: Boolean,
      default: false,
    },
    mensagemErro: String,
    placeholder: {
      type: String,
      default: "Selecione",
    },
    classDiv: {
      type: String,
      default: "col",
    },
    modelValue: null,
    editavel: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    DropDown,
  },
};
</script>